import { EventForm } from "./EventForm";

export function EventCreatePage() {
  return <EventForm mode="create" />;
}
